import { breakpoint, colors, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  currencySelectorContainer: css({
    display: 'flex',
    flexDirection: 'row',
    marginRight: 'auto',
    marginLeft: 0,
    fontSize: fontSize.default,
    color: colors.scorpion,
    fontWeight: fontWeight.semiBold,
    lineHeight: '14px',

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginLeft: 'auto',
      marginRight: 0,
      fontSize: fontSize.small,
      fontWeight: fontWeight.medium,
    },
  }),

  clickableContainer: css({
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    alignItems: 'baseline',
  }),

  currencyInfo: css({
    display: 'flex',
    alignItems: 'center',
    marginLeft: spacing.small,
    lineHeight: '16px',
  }),

  currencyText: css({
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.default,
    marginRight: spacing.small,

    [mediaQueryHelper(breakpoint.phone)]: {
      fontWeight: fontWeight.medium,
      fontSize: fontSize.small,
    },
  }),

  currencyModal: css({
    backgroundColor: colors.white,
    position: 'absolute',
    width: 273,
    border: `1px solid ${colors.mystic}`,
    boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: 3,
    transform: `translateY(${spacing.medium}px)`,
    marginRight: 0,
    zIndex: 2,

    div: {
      display: 'flex',
      flexDirection: 'column',
    },

    fieldset: {
      padding: 20,
      paddingRight: 0,
    },

    label: {
      fontSize: fontSize.default,
      lineHeight: '17px',
      fontWeight: fontWeight.regular,
      color: colors.blackPearl,
      padding: 0,

      '::before': {
        width: 30,
        height: 30,
      },

      '::after': {
        width: '22px !important',
        height: '22px !important',
      },

      [mediaQueryHelper(breakpoint.phone)]: {
        '::before': {
          width: 20,
          height: 20,
        },

        '::after': {
          width: '12px !important',
          height: '12px !important',
        },
      },
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      transform: `translate(-100px, 18px)`,
      width: 245,
    },
  }),
}

export default styles
